module.exports = __webpack_public_path__ + "img/skip-backward.8aaf6fc1.svg";